import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Head from "../components/Head";
import Foot from "../components/Foot";
import StoryTemplate from "./StoryTemplate";
import OverviewTemplate from "./OverviewTemplate";
import CoursePage from "./CoursePage";

const apiUrl = process.env.REACT_APP_API_URL;

// Catch-all for any slug not matched by a static route. Checks the About Us
// CMS first; if nothing matches there, falls through to CoursePage, which
// handles the Course CMS lookup and its own not-found state.
function DynamicPage() {
  const { slug } = useParams();
  const [checked, setChecked] = useState(false);
  const [aboutPage, setAboutPage] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setChecked(false);
    setAboutPage(null);
    axios
      .get(`${apiUrl}/api/public/about-pages/${slug}`)
      .then((res) => {
        if (!cancelled && res.data.success) setAboutPage(res.data.aboutPage);
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setChecked(true);
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (!checked) {
    return (
      <>
        <Head />
        <div className="container text-center" style={{ padding: "120px 0" }}>
          <p>Loading...</p>
        </div>
        <Foot />
      </>
    );
  }

  if (aboutPage) {
    return aboutPage.template === "overview" ? (
      <OverviewTemplate page={aboutPage} />
    ) : (
      <StoryTemplate page={aboutPage} />
    );
  }

  return <CoursePage />;
}

export default DynamicPage;
